/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';
import type { StartDateType } from './';
import {
    StartDateTypeFromJSON,
    StartDateTypeFromJSONTyped,
    StartDateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface AsapStartDate
 */
export interface AsapStartDate extends StartDate {
}

/**
 * Check if a given object implements the AsapStartDate interface.
 */
export function instanceOfAsapStartDate(value: object): value is AsapStartDate {
    return true;
}

export function AsapStartDateFromJSON(json: any): AsapStartDate {
    return AsapStartDateFromJSONTyped(json, false);
}

export function AsapStartDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AsapStartDate {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function AsapStartDateToJSON(value?: AsapStartDate | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...StartDateToJSON(value, true),
    };
}

